import React, { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import TitlePage from '../../../components/TitlePage';
import { ApplicationState } from '../../../store';
import Filter from './Filter';
import { Container } from './styles';
import { ColumnType } from 'antd/lib/table';
import ModalCadastroMotorista from './components/ModalCadastroMotorista';
import mask, { formatPhoneNumber } from '../../../utils/mask';
import TableSort from '../../../components/TableSort';
import { useWindowSize } from '../../../hook/useWindowSize';
import CardMobile from './components/CardMobile';
import { loadRequest } from '../../../store/ducks/motorista/actions';
import TextTable from '../../../components/TextTable';
import Refresh from '../../../components/Refresh';
import ModalEditarMotorista from './components/ModalEditarMotorista';
import { Button, Dropdown, Menu, Popconfirm, notification } from 'antd';
import { DeleteOutlined, EllipsisOutlined } from '@ant-design/icons';
import { IMotorista } from '../../../store/ducks/motorista/types';
import { delMotoristaServices } from './services/cadMotoristaServices';
import ModalAddBlackList from './components/addBlackList';

const CadastroMotorista: React.FC = () => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const { width }: any = useWindowSize();

  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const motorista = useSelector((state: ApplicationState) => state.Motorista.data);
  const loading = useSelector((state: ApplicationState) => state.Motorista.loading);
  const filter = useSelector((state: ApplicationState) => state.Motorista.filter);
  const pagination = useSelector((state: ApplicationState) => state.Motorista.pagination);

  const confirm = async (e: number) => {
    try {
      await delMotoristaServices.delMotorista(e, inscricaoAtiva).then((res) => {
        notification.success({
          message: 'Motorista removido com sucesso!',
          placement: 'bottomRight',
        });
        dispatch(loadRequest(inscricaoAtiva, filter, pagination));
      });
    } catch (error: any) {
      if (error.response.data.Erro) {
        return notification.error({
          message: error.response.data.Erro,
          placement: 'bottomRight',
        });
      }
      notification.error({
        message: 'Não foi possível remover o motorista, tente novamente ou contate o suporte.',
        placement: 'bottomRight',
      });
    }
  };

  const columns: ColumnType<IMotorista>[] = [
    {
      title: 'Nome',
      dataIndex: 'nome',
      key: 'nome',
      width: 400,

      render: (text: string) => {
        return <TextTable>{mask('camelCase', text)}</TextTable>;
      },
    },
    {
      title: 'CPF',
      dataIndex: 'cpf',
      key: 'cpf',
      align: 'center',
      render: (text: string) => {
        return <TextTable>{mask('cpfCnpj', text)}</TextTable>;
      },
    },
    {
      title: 'Telefone',
      dataIndex: 'telefone',
      key: 'telefone',
      align: 'center',
      render: (text: string) => {
        return <TextTable>{text ? formatPhoneNumber(text) : 'Não informado'}</TextTable>;
      },
    },
    {
      title: 'CNH',
      dataIndex: 'habilitado',
      key: 'habilitado',
      align: 'center',
      render: (text: string) => {
        return <TextTable>{text}</TextTable>;
      },
    },

    {
      title: 'MOPP',
      dataIndex: 'mopp',
      key: 'mopp',
      align: 'center',
      render: (text: string) => {
        return <TextTable>{text ? 'Sim' : 'Não'}</TextTable>;
      },
    },

    {
      title: 'Ação',
      dataIndex: 'acao',
      key: 'acao',
      width: 100,
      fixed: 'right',
      render: (text: any, record: any) => {
        const menuDropDown = (
          <Menu>
            <Menu.Item data-cy="btn-editar" className="themeOrdemCargaAcao">
              <ModalEditarMotorista record={record} />
            </Menu.Item>
            <Menu.Item data-cy="btn-excluir" className="themeOrdemCargaAcao">
              <Popconfirm
                title="Tem certeza que deseja remover esse motorista?"
                onConfirm={() => confirm(record.codMotorista)}
                okText="Sim"
                cancelText="Não"
              >
                <Button icon={<DeleteOutlined />}>Excluir</Button>
              </Popconfirm>
            </Menu.Item>

            <Menu.Item data-cy="btn-adicionar-blacklist" className="themeOrdemCargaAcao">
              <ModalAddBlackList record={record} />
            </Menu.Item>
          </Menu>
        );
        return (
          <Dropdown overlay={menuDropDown}>
            <Button
              data-cy="btn-acoes"
              type="text"
              className="ant-dropdown-link"
              onClick={(e) => e.preventDefault()}
            >
              <EllipsisOutlined
                style={{ fontSize: '30px', transform: 'rotate(90deg)', color: '#3c6ab4' }}
              />
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  return (
    <>
      <Filter />
      <Refresh loadRequest={() => dispatch(loadRequest(inscricaoAtiva, filter, pagination))} />
      <Container>
        <TitlePage>
          Cadastro de motorista
          <div className="box">
            <ModalCadastroMotorista />
          </div>
        </TitlePage>

        {width > 768 && (
          <TableSort
            scroll={{ x: 1200 }}
            style={{ fontSize: 10, display: 'inline' }}
            columns={columns}
            size={'large'}
            onChange={(pagination: any, filters: any, sorter: any) => {
              dispatch(loadRequest(inscricaoAtiva, filter, pagination));
            }}
            pagination={pagination}
            className="table"
            dataSource={motorista}
            loading={loading}
            // rowClassName={(record: any) => (record.ativo ? '' : 'disabled-row')}
          />
        )}

        {width <= 768 && (
          <>
            <CardMobile
              props={motorista}
              loading={loading}
              inscricaoAtiva={inscricaoAtiva}
              cddAtivo={cddAtivo}
            />
          </>
        )}
      </Container>
    </>
  );
};

export default CadastroMotorista;
